import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const failedCaptures = {
  data: () => ({
    failedCaptures: [],
    listConfig: {
      page: 0,
      maxPerPage: 10,
      sort: '-date',
      dateType: 'transactionDate',
      startDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endDate: dayjs().subtract(1, 'month').endOf('month').format(),
      dynamicSearch: '',
    },
    listLoading: true,
    listInfo: {
      totalCount: 0,
    },
  }),
  methods: {
    async listFailedCaptures() {
      this.listLoading = true;
      const { data, headers } = await this.$store.dispatch('charges/listCharges', { ...this.listConfig, status: 'capture-failed' });
      this.listLoading = false;
      if (data) {
        this.failedCaptures = data;
      }
      this.listInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};
